import { trackBookingFlowContext } from 'noddi-web';
import { useEffect } from 'react';
import { useServiceCenter, useStationaryBookingCar } from '../stores/StationaryBookingStore';

// Tags the OpenPanel session with plate + chosen service center so support can
// find a customer's replay.
export function useTrackStationaryBookingFlowContext() {
  const licensePlate = useStationaryBookingCar()?.licensePlate.number;
  const serviceDepartmentName = useServiceCenter()?.name;

  useEffect(() => {
    trackBookingFlowContext({
      locationType: 'stationary',
      licensePlates: licensePlate ? [licensePlate] : [],
      serviceDepartmentName
    });
  }, [licensePlate, serviceDepartmentName]);
}
